module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.ttf?5bdaa8582fd409b4a3fd9f03916de415";